
import { type PropType, defineComponent } from "vue";

import LtkHeaderMenuItems from "./LtkHeaderMenuItems.vue";
import { type NavItem } from "./types";
// Naming without c- prefix to avoid recursive lookups from vuetify-loader
import { CBtn, CMenu, CToolbarItems } from "../../vuetify-components";

export default defineComponent({
  components: { CBtn, CMenu, CToolbarItems, LtkHeaderMenuItems },
  props: {
    nuxt: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array as PropType<NavItem[]>,
      default: () => [],
    },
  },
  emits: {
    "nav-click": (_v: NavItem) => true,
  },
});
